import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ComingSoon } from "@/components/ui/coming-soon";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { ScrollableContainer } from "@/components/ui/scrollbar";

export const Route = createFileRoute("/(protected)/management/dashboard/")({
  component: ManagementDashboard,
});

function ManagementDashboard() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mt-5 mb-4 px-6">
          {t("pages:management.sidebar.dashboard")}
        </MobilePageTitle>
        <ComingSoon
          title={t("pages:management.dashboard.comingSoon.title")}
          description={t("pages:management.dashboard.comingSoon.description")}
        />
      </div>
    </ScrollableContainer>
  );
}
